import styled from '@emotion/styled'

export const LottieAnimationWrapper = styled.div``
